import * as z from 'zod'

export interface Address {
  country: string | null
  region: string | null
  city: string | null
  postalCode: string | null
  addressLine: string | null
  additionalInfo: string | null
}

export const DEFAULT_ADDRESS = {
  country: '',
  region: '',
  city: '',
  postalCode: '',
  addressLine: '',
  additionalInfo: '',
}

export const AddressFieldsSchema = z.object({
  country: z.string(),
  region: z.string(),
  city: z.string(),
  postalCode: z.string(),
  addressLine: z.string(),
  additionalInfo: z.string(),
})

export const RequiredAddressSchema = AddressFieldsSchema.extend({
  country: z.string().trim().min(1),
  city: z.string().trim().min(1),
  addressLine: z.string().trim().min(1),
  postalCode: z.string().trim().min(1),
})

export type AddressFieldsSchema = z.infer<typeof AddressFieldsSchema>

export function getAddressFieldsDefaultValues(
  address: Address | undefined,
  defaultValues: Partial<Address> = {}
): AddressFieldsSchema {
  return {
    country: address?.country || defaultValues.country || '',
    region: address?.region || defaultValues.region || '',
    city: address?.city || defaultValues.city || '',
    postalCode: address?.postalCode || defaultValues.postalCode || '',
    addressLine: address?.addressLine || defaultValues.addressLine || '',
    additionalInfo: address?.additionalInfo || defaultValues.additionalInfo || '',
  }
}
